// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"af2408ac","1067":"92d241ca","6285":"cf14f9d5","7633":"71fef7a2","8400":"87594367"}[chunkId] + ".chunk.css";
};